import { render, staticRenderFns } from "./wordPage.vue?vue&type=template&id=50604dcc&scoped=true"
import script from "./wordPage.vue?vue&type=script&lang=js"
export * from "./wordPage.vue?vue&type=script&lang=js"
import style0 from "./wordPage.vue?vue&type=style&index=0&id=50604dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50604dcc",
  null
  
)

export default component.exports